module.exports = __webpack_public_path__ + "static/media/cg.c8c05bfe.svg";